module.exports = __webpack_public_path__ + "img/Reserve.0b8b3d5f.png";